export default __webpack_public_path__ + "static/media/787.2273e0ba.png";